import { render, staticRenderFns } from "./DataViewSelectMenuSection.vue?vue&type=template&id=204e0ece&scoped=true"
import script from "./DataViewSelectMenuSection.vue?vue&type=script&lang=ts"
export * from "./DataViewSelectMenuSection.vue?vue&type=script&lang=ts"
import style0 from "./DataViewSelectMenuSection.vue?vue&type=style&index=0&id=204e0ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e0ece",
  null
  
)

export default component.exports